import { useEffect, useState } from "react";
/* Importing Components */
import {
  Map,
  SearchLocationBar,
} from "../../../../components/parts";
import { CardWrapper } from "../../../../components/wrapper";
import { useAuth } from "../../../../context/AuthProvider";
/* Importing Stylesheet */
import styles from "./style.module.scss";
import { Loader } from "../../../../components/ui";
import { GET_API_URLS } from "../../../../utils/constant";
import jwtInterceoptor from "../../../../api/jwtInterceptor";
import CancoLocationCard from "../../../../components/parts/cancoLocationCard";

const Locations = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [location, setLocation] = useState(null);
  const [filteredLocationData, setFilteredLocationData] = useState(false);
  const [totalLocation, setTotalLocation] = useState(0);
  const { setAuth } = useAuth();

  useEffect(() => {
    jwtInterceoptor
      .get(GET_API_URLS.STORE_URL)
      .then((response) => {
        setLoading(false);
        setLocation(response.data);
      })
      .catch((error) => {
        setLoading(false);
        setError(error.message);
        console.log("Error", error);
      });
  }, [setAuth]);

  useEffect(() => {
    // jwtInterceoptor
    //   .get(GET_API_URLS.CITIES)
    //   .then((response) => {
    //     setAuth((prev) => ({ ...prev, cities: response.data }));
    //   })
    //   .catch((error) => {
    //     console.log("city Error", error);
    //   });

    jwtInterceoptor
      .get(GET_API_URLS.PROVINCE)
      .then((response) => {
        setAuth((prev) => ({ ...prev, province: response.data }));
      })
      .catch((error) => {
        console.log("city Error", error);
      });
  }, [setAuth]);

  useEffect(() => {
    if (location) {
      setTotalLocation(location.length);
    }
  }, [location, setTotalLocation]);

  return (
    <div className={styles.locationsPageContainer}>
      <CardWrapper className={styles.mapBlock}>
        <Map
          locationData={
            loading
              ? null
              : error
              ? "There was a problem while loading the data"
              : location
          }
          error={error}
        />
      </CardWrapper>
      {location && (
        <CardWrapper className={styles.locationSearchSection}>
          <div>
            <h2>Search Location</h2>
            <SearchLocationBar
              locations={location}
              filteredData={(data) => {
                setFilteredLocationData(data);
              }}
            />
          </div>
          <div>
            <h2>Total Location</h2>
            <h2>{totalLocation}</h2>
          </div>
        </CardWrapper>
      )}
      <div className={styles.locationBlock}>
        {loading ? (
          <Loader />
        ) : error ? (
          <h3>There was a problem while loading the data.</h3>
        ) : (
          filteredLocationData &&
          filteredLocationData.map((store, i) => {
            return (
              <CancoLocationCard
                storeId={store.id}
                storeName={store.name}
                businessType={store.business_type.name}
                storeImg={store.image}
                address={store.address}
                longitude={store.longitude}
                latitude={store.latitude}
                amenities={store.amenities}
                gasTypes={store.gas_types}
                is24by7={store.is24by7}
                timings={store.timings}
                storeData={store}
                key={i}
              />
            );
          })
        )}
      </div>
    </div>
  );
};

export default Locations;
